export const SET_TENANT = "SET_TENANT";
export const SET_TENANT_SUCCESS = "SET_TENANT_SUCCESS";
export const SET_TENANT_FAILED = "SET_TENANT_FAILED";
